import {fetchBody, body2String} from "../config"
import Swal from 'sweetalert2'

export const cleanFetch = ({body, url, success, failure}) => {
  //console.log(obj)
  //console.log(url)
  //console.log(body.body)
  fetch(url, body)
  .then((response) => {
    //console.log(response);
    //console.log(response.status);    
    //console.log(response.body);
    if (!response.ok) {
      throw new FetchError(response.status, response.statusText, response)
    }else{
      return response.json();
    }
  }).then((jsonDate)=>{
    //console.log("jsonDate :")
    //console.log(url);
    //console.log(jsonDate.accessToken === undefined);
    //console.log(jsonDate);
    if(jsonDate.status){
      if(success !== undefined)
      success(jsonDate);
    }else{
      if(jsonDate.isLogout){
        toLogout()
      }else{
        if(failure !== undefined)
          failure(jsonDate.message)
      }
    }
  }).catch((err)=>{
    console.log(err);
    if(err.toString() === "TypeError: Failed to fetch"){
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: "網路發生問題, 請檢查",
      }).then(function() {
        //Auth.logout()
      })
      failure(err.message);
    }else{
      switch(err.code){
        case 401:
          toLogout(err.message)
          failure(err.message);
          break;
        case 500:
          err.message = '系統發生錯誤, 請聯繫客服'
          if(failure !== undefined)
            failure(err);
          break
        default:
          console.log(err)
          if(failure !== undefined)
            failure(err);
          //console.log(err.response.json)
          
          err.response.json().then(body=>{
            if(typeof body === "object"){
              err.body = JSON.stringify(body)
              //console.log(JSON.stringify(err.body))
            }else{
              err.body = body
            }
            console.log(body)
            //getReader(err.body)
            //console.log(err)
            failure(body);
          }).catch((bodyerr)=>{
            console.log(err.message)
            //console.log(bodyerr)
            //console.log(err)
            err.body = err.message
            failure(err);
          })
          break;
      }

    }
  })
}

function FetchError(code, message, response){
  this.code = code;
  this.message = message;
  this.response = response
  this.body = ""
}
/*
export const cleanFetch = (obj, url, success, failure) => {
  fetch(url, fetchBody(body2String(obj)))
  .then((response) => {
    return response.json();
  }).then((jsonDate)=>{
    //console.log("jsonDate :")
    //console.log(url);
    //console.log(jsonDate);
    if(!jsonDate.status){
      failure(jsonDate)
    }else{
      success(jsonDate);
    }        
  }).catch((err)=>{
    console.log("錯誤 :", err)
  })
}
*/

export const toFetch = (obj, url, success, failure, failureMessage) => {
  var from = url.split("/").slice(4)
    fetch(url, fetchBody({body: body2String(obj)}))
    .then((response) => {
      return response.json();
    }).then((jsonDate)=>{
      //console.log("jsonDate :")
      //console.log(url);
      //console.log(jsonDate);
      if(!jsonDate.status){
        checkLogout(jsonDate, failure, failureMessage, from[0])
      }else{
        success(jsonDate);
      }        
    }).catch((err)=>{
      console.log("錯誤 :", err)
    })
}



export const checkLogout = (obj, fn, failureMessage='發生錯誤, 請洽詢技術人員', url) =>{

    if(obj.isLogout){
      toLogout()
    }else{
      failureMessage += "["+url+"]"+JSON.stringify(obj);
      Swal.fire({
        type: 'error',
        title: '提醒',
        text: failureMessage,
      }).then(function() {
        fn()
      })
    }
  }

  export const toLogout = () => {
    Swal.fire({
      type: 'error',
      title: '提醒',
      text: '登入逾期, 請重新登入',
    }).then(function() {
      window.location.replace("/logout");
    })
  }